import { ChevronDownIcon, ChevronUpIcon, PencilSquareIcon, TrashIcon } from '@heroicons/react/24/solid'
import ItemWithQuantity from 'components/ItemWithQuantity'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRemoveItemFromRecipeMutation } from '../queries'
import { RecipeItem } from '../types'

interface EditRecipeItemProps {
    item: RecipeItem
    recipeId: number
    onSortDown: () => void
    onSortUp: () => void
}

function EditRecipeItem({ item: { name, item_quantity, recipe_item_id }, recipeId, onSortUp, onSortDown }: EditRecipeItemProps) {
    const navigate = useNavigate()

    const [isBeingRemoved, setIsBeingRemoved] = useState(false)

    const { mutate: removeItemFromRecipe } = useRemoveItemFromRecipeMutation()

    function removeItem() {
        removeItemFromRecipe({ recipeId: recipeId.toString(), recipeItemId: recipe_item_id })
    }

    return (
        <li
            className={`flex justify-between items-center w-full rounded-md relative top-0 left-0 h-8${
                isBeingRemoved ? ' top-24 left-52 opacity-0 h-0 transition-all duration-200 ease-linear' : ''
            }`}
        >
            <ItemWithQuantity quantityValue={item_quantity.quantity} unitSymbol={item_quantity.quantity_unit?.symbol} itemName={name} />
            <div className='flex items-center gap-2'>
                <button type='button' onClick={onSortUp}>
                    <ChevronUpIcon className={`w-5 text-primary hover:text-primary-hover`} />
                </button>
                <button type='button' onClick={onSortDown}>
                    <ChevronDownIcon className={`w-5 text-primary hover:text-primary-hover`} />
                </button>
                <button
                    type='button'
                    onClick={() => {
                        navigate(`/recipes/edit/${recipeId}/update-item-quantity/${recipe_item_id}`)
                    }}
                >
                    <PencilSquareIcon className={`w-5 text-primary hover:text-primary-hover${isBeingRemoved ? ' hidden' : ''}`} />
                </button>
                <button
                    type='button'
                    onClick={() => {
                        setIsBeingRemoved(true)
                        setTimeout(() => {
                            setIsBeingRemoved(false)
                            removeItem()
                        }, 200)
                    }}
                >
                    <TrashIcon className={`w-5 text-primary hover:text-primary-hover${isBeingRemoved ? ' hidden' : ''}`} />
                </button>
            </div>
        </li>
    )
}

export default EditRecipeItem
